/* eslint-disable indent */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
    FETCH_GTD_LOGS_SUCCESS,
    FETCH_SELECTED_LOG_INFORMATION,
    FETCHING_GTD_LOGS,
    FETCHING_SELECTED_LOG_INFORMATION
  } from './LogConstants';


const initialState = {
    fetchingGTDLogs: false,
    fetchingSelectedLogInformation: false,
    gtdLogInformation: {},
    gtdLogs: [],
};

const LogReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCHING_GTD_LOGS:
        return {
          ...state,
          fetchingGTDLogs: true
        };
      case FETCH_GTD_LOGS_SUCCESS: 
        return {
          ...state,
          gtdLogs: action.gtdLogs,
          fetchingGTDLogs: false
        };
      case FETCH_SELECTED_LOG_INFORMATION:
        return {
          ...state,
          fetchingSelectedLogInformation: false,
          gtdLogInformation: action.logInformation
        };
      case FETCHING_SELECTED_LOG_INFORMATION:
          return {
            ...state,
            fetchingSelectedLogInformation: true
          };
      default:
        return state;
    }
  };
  
export default LogReducer;


// WEBPACK FOOTER //
// ./src/redux/logs/LogReducer.js